import React from 'react';

interface DirectElectronicDepositIconProps {
  height?: number;
  width?: number;
  color?: string;
}

const DirectElectronicDepositIcon: React.FC<DirectElectronicDepositIconProps> = ({ height, width, color = '#FFD700' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 500 500"
      width={`${width}pt`}
      height={`${height}pt`}
    >
      <path
        style={{ fill: color }}
        d="M308.77 85.81v19.59h-11.63l15.24 23.09 16-23.09h-11.61V85.81a21.3 21.3 0 0 0-21.28-21.29h-14.77v8h14.77a13.3 13.3 0 0 1 13.28 13.29M200.26 404.9h-19.59a13.29 13.29 0 0 1-13.28-13.28v-14.77h-8v14.77a21.3 21.3 0 0 0 21.28 21.28h19.59v11.62l23.09-16-23.09-15.24ZM264.53 326.38V77.73a43.44 43.44 0 0 0-43.39-43.39H110a43.43 43.43 0 0 0-43.39 43.39v248.65a34.86 34.86 0 0 0 34.83 34.83H229.7a34.87 34.87 0 0 0 34.83-34.83m-34.83 26.83H101.44a26.85 26.85 0 0 1-26.83-26.83V77.73A35.42 35.42 0 0 1 110 42.34h111.14a35.43 35.43 0 0 1 35.39 35.39v248.65a26.86 26.86 0 0 1-26.83 26.83"
      ></path>
      <path
        style={{ fill: color }}
        d="M236.53 74.69H94.6a7 7 0 0 0-6.94 6.94v239.6a7 7 0 0 0 6.94 6.94h141.93a7 7 0 0 0 6.94-6.94V81.63a6.94 6.94 0 0 0-6.94-6.94m-1.06 245.48H95.66V82.69h139.81ZM148.71 65.63h33.71a4.06 4.06 0 1 0 0-8.11h-33.71a4.06 4.06 0 1 0 0 8.11"
      ></path>
      <path
        style={{ fill: color }}
        d="M146.84 238.28a18.6 18.6 0 0 1-4.29-11.08h-21q0 14.09 10 22.68T157.67 260v13.92h11.16V260a43 43 0 0 0 19.33-6.19 35.3 35.3 0 0 0 12.37-12.71 32.63 32.63 0 0 0 4.21-16.1q0-11.34-5-17.79a29.74 29.74 0 0 0-12.2-9.45 126 126 0 0 0-18.71-5.76v-37.14a18.3 18.3 0 0 1 9.63 5.76 16.9 16.9 0 0 1 4.12 9.54h21q-1.2-14.26-10.39-22.43t-24.32-9.53v-13.92h-11.2v13.92q-16.15 1.55-26.12 10.91t-10 23.62q0 11.34 5.07 17.87a29.94 29.94 0 0 0 12.29 9.54 139.4 139.4 0 0 0 18.73 5.93v37.8q-7.02-1.2-10.8-5.59m22-29.29q7.74 2.4 11.95 6.27T185 226a17.27 17.27 0 0 1-4.29 11.77 19.2 19.2 0 0 1-11.86 6.1Zm-23.12-26.29q-4.2-4-4.21-11 0-7.56 4.39-12a19 19 0 0 1 11.77-5.32v34.71q-7.74-2.44-11.95-6.39M390 137H280.53v8H390a35.44 35.44 0 0 1 35.4 35.4v248.66a26.87 26.87 0 0 1-26.83 26.83H270.3a26.87 26.87 0 0 1-26.83-26.83v-53.74a51.4 51.4 0 0 1-8 1.56v52.18a34.87 34.87 0 0 0 34.83 34.83h128.27a34.87 34.87 0 0 0 34.83-34.83V180.4A43.45 43.45 0 0 0 390 137"
      ></path>
      <path
        style={{ fill: color }}
        d="M404.34 422.84H264.53v-59.47a50.4 50.4 0 0 1-8 6.16v54.37a6.94 6.94 0 0 0 6.94 6.94H405.4a7 7 0 0 0 6.94-6.94V184.3a7 7 0 0 0-6.94-6.94H280.53v8h123.81Z"
      ></path>
      <rect width="41.83" height="8.11" x="313.52" y="160.2" style={{ fill: color }} rx="4.06"></rect>
      <path
        style={{ fill: color }}
        d="M315.71 341a18.58 18.58 0 0 1-4.3-11.08h-21q0 14.08 10 22.68t26.12 10.13v13.92h11.17v-13.96a43.06 43.06 0 0 0 19.3-6.18 35.5 35.5 0 0 0 12.37-12.72 32.74 32.74 0 0 0 4.21-16.15q0-11.34-5-17.78a29.64 29.64 0 0 0-12.2-9.45 127.7 127.7 0 0 0-18.73-5.76v-37.11a18.3 18.3 0 0 1 9.62 5.75 16.82 16.82 0 0 1 4.12 9.54h21q-1.21-14.26-10.4-22.42t-24.31-9.54V227h-11.15v13.91q-16.15 1.55-26.12 10.91t-10 23.63q0 11.34 5.07 17.87a29.9 29.9 0 0 0 12.28 9.53 138 138 0 0 0 18.73 5.93v37.8q-7.01-1.24-10.78-5.58m22-29.3q7.73 2.41 11.94 6.27t4.21 10.74a17.2 17.2 0 0 1-4.3 11.77q-4.29 4.9-11.85 6.1Zm-23.11-26.29q-4.21-3.94-4.21-11 0-7.56 4.38-12t11.76-5.41v34.71q-7.72-2.38-11.94-6.34Z"
      ></path>
    </svg>
  );
};

export default DirectElectronicDepositIcon;
